import { createSelector } from 'reselect';
import { get } from 'lodash';
import * as moment from 'moment';

import { localStorage } from 'services';
import {
  loginSuccessAction,
  authAnonymousSuccessAction,
} from 'store/auth/action';

export const getAuthData = createSelector(
  state => {
    return state.auth.loginData.data;
  },
  data => data,
);

export const getAuthAllData = createSelector(
  state => {
    return state.auth;
  },
  auth => auth,
);

export const getPatientLoginData = createSelector(
  state => {
    return state.auth.patientLoginInfo;
  },
  patientLoginInfo => patientLoginInfo,
);

export const getSendVerifyDataChangePassword = state =>
  get(state, 'auth.sendVerifyData.verifyItem');

export const getRecoveryPassword = state => get(state, 'sendVerifyData');
export const getConfirmVerifyCodeChangePassword = state =>
  get(state, 'auth.confirmRecoveryPassword');

export const checkAuthenticationStatus = createSelector(
  state => (state && state.auth ? state.auth.loginData.data : null),
  authData => {
    const auth = localStorage.getAuth() || authData;
    const ELAPSE_TIME = 1;
    let isAuthenticated = false;
    const expiredAt = get(auth, 'expiredAt');
    const patientId = get(auth, 'patientId');

    const expireTime = moment.unix(expiredAt);
    const now = moment();
    const distanceTime = expireTime.diff(now, 'hour');

    if (patientId) {
      if (distanceTime > ELAPSE_TIME) {
        isAuthenticated = true;
      }
    } else {
      if (distanceTime > ELAPSE_TIME) {
        isAuthenticated = true;
      }
    }

    return {
      isAuthenticated,
      isUser: patientId ? true : false,
      data: auth,
    };
  },
);
